import { render, staticRenderFns } from "./Workshop.vue?vue&type=template&id=4b1d78dc&scoped=true&"
import script from "./Workshop.vue?vue&type=script&lang=js&"
export * from "./Workshop.vue?vue&type=script&lang=js&"
import style0 from "./Workshop.vue?vue&type=style&index=0&id=4b1d78dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1d78dc",
  null
  
)

export default component.exports